import store from '../src/store';
const axios = require('axios');
const _conf = require('./js/_conf');
const config =
 _conf.env_type == 1 //判断环境
 ?
 {
  //测试环境
  baseUrl: 'https://uatpmsapi.house730.com.cn/', //uat
  // baseUrl: '//10.104.10.46:5000/', //闹闹接口地址
  //  baseUrl: '//10.29.204.68:8521/', //闹闹接口地址
  pcUrl: '//uat.house730.com.cn/', //pc端官网
  wapUrl: '//uatm.house730.com.cn/', //wap端官网地址
  pcPassport: '//uatpush.house730.com/', //pc端个人中心地址
  wapPassport: '//uatm.house730.com/my/', //wap端个人中心地址
  wapScan: 'http://uatpms.house730.com.cn/m/scan', //wap端上传图片
  googleVerify: '//www.recaptcha.net/recaptcha/api.js', //谷歌验证码SDK
  paypalSdk: 'https://www.paypal.com/sdk/js?client-id=AcHCQSYeG6565Zw9lpfKIxH8a_QRAhwjHiqa2XtNASinpDJG-WZFqI_q-tetN1xCvDiMvhPDQBDv-qKR&currency=HKD&locale=zh_HK', //paypal支付SDK pc端
  static: '//auatstatic.house730.com/m/',
  wapPms: '//uatpms.house730.com.cn/m/',
  qrDownApp: 'http://uatpms.house730.com.cn/m/downapp',
 } :
 _conf.env_type == 2 ? {
  //预上线环境环境配置
  baseUrl: '//uatpmsapi.house730.com.cn/', //香港服务器接口地址
  pcUrl: '//uat.house730.com.cn/', //pc端官网
  wapUrl: '//uatm.house730.com.cn/', //wap端官网地址
  pcPassport: '//uatpush.house730.com.cn/', //pc端个人中心地址
  wapPassport: '//uatm.house730.com.cn/my/', //wap端个人中心地址
  wapScan: 'http://uatpms.house730.com.cn/m/scan', //wap端上传图片
  googleVerify: '//www.recaptcha.net/recaptcha/api.js', //谷歌验证码SDK
  paypalSdk: 'https://www.paypal.com/sdk/js?client-id=AcHCQSYeG6565Zw9lpfKIxH8a_QRAhwjHiqa2XtNASinpDJG-WZFqI_q-tetN1xCvDiMvhPDQBDv-qKR&currency=HKD&locale=zh_HK', //paypal支付SDK pc端
  static: '//auatstatic.house730.com/m/',
  wapPms: '//uatpms.house730.com.cn/m/',
  qrDownApp: 'http://uatpms.house730.com.cn/m/downapp',
 } : 
 _conf.env_type == 4 ? {
  //预上线环境环境配置
  baseUrl: '//simpmsapi.house730.com/', //香港服务器接口地址
  pcUrl: '//sim.house730.com/', //pc端官网
  wapUrl: '//simm.house730.com/', //wap端官网地址
  pcPassport: '//simpush.house730.com/', //pc端个人中心地址
  wapPassport: '//simm.house730.com/my/', //wap端个人中心地址
  wapScan: 'https://simpms.house730.com/m/scan', //wap端上传图片
  googleVerify: '//www.recaptcha.net/recaptcha/api.js', //谷歌验证码SDK
  paypalSdk: 'https://www.paypal.com/sdk/js?client-id=AUGVraiRde38KWLBaGvKHlOnNAoMbvmlPp7bn5AXPyM5855hot4qat-MAXiAKWCDM4AlthzuraLSBvTl&currency=HKD&locale=zh_HK', //paypal支付SDK
  static: '//auatstatic.house730.com/m/',
  wapPms: '//simpms.house730.com/m/',
  qrDownApp: 'https://pms.house730.com/m/downapp',
 } : {
  //线上环境配置
  // pcUrl: '//10.29.205.217:8500/',
  baseUrl: '//pmsapi.house730.com/', //香港服务器接口地址
  pcUrl: '//www.house730.com/', //pc端官网222222
  wapUrl: '//m.house730.com/', //wap端官网地址
  pcPassport: '//push.house730.com/', //pc端个人中心地址
  wapPassport: '//m.house730.com/my/', //wap端个人中心地址
  wapScan: 'https://pms.house730.com/m/scan', //wap端上传图片
  googleVerify: '//www.recaptcha.net/recaptcha/api.js', //谷歌验证码SDK
  paypalSdk: 'https://www.paypal.com/sdk/js?client-id=AUGVraiRde38KWLBaGvKHlOnNAoMbvmlPp7bn5AXPyM5855hot4qat-MAXiAKWCDM4AlthzuraLSBvTl&currency=HKD&locale=zh_HK', //paypal支付SDK
  static: '//static.house730.com/m/',
  wapPms: '//pms.house730.com/m/',
  qrDownApp: 'https://pms.house730.com/m/downapp',

 };
const routeNameLists = {
 HelpIndex:'Help_HelpIndex', 
 MainBody:'Help_MainBody',
 HelpCateList:'Help_CateList',
 HelpSearchResult:'Help_SearchResult',


 HomeBase: 'HomeBase', //导航基础路由组件
 Home: 'Home', //首页
 HomePage: 'Home_HomePage', //首页-首页
 ChangePassword: 'ChangePassword', // 更改密码
 Personal: 'Personal', // 个人中心
 PersonalCenter: 'PersonalCenter', //个人中心_个人中心
 System: 'System', //业务设置
 Company: 'System_CompanyProfile', //业务设置-公司资料
 DepartmentManage: 'System_Branch', //业务设置-分行管理
 SystemOrg: 'System_Org', //业务设置-组织管理
 RolePermission: 'System_Role', //业务设置-角色权限管理
 StaffingIndex: 'System_Employee', //业务设置-员工管理
 Journal: 'System_Operation', //业务设置-操作日志
 Deal:'System_Deal',//业务设置-成交数据
 SubDeal:'System_SubDeal',//业务设置-成交数据
 Coin: 'Coin', //金币管理
 CoinIndex: 'Coin_CoinManage', //金币管理-金币管理
 ManageOrganization: 'Coin_Org', //金币管理-组织账户
 ManagePersonal: 'Coin_Private', //金币管理-个人账户
 CoinRecord: 'Coin_Record', //金币管理-金币记录
 CoinCoupon:'Coin_Coupon',//金币管理-优惠码兑换
 CoinPayment: 'Coin_PaymentMethod', //金币管理-付款方式
 Property: 'Property', //楼盘管理
 PropertyIndex: 'Property_PropertyManage', //楼盘管理-楼盘管理
 DraftBox: 'Property_DraftBox', //楼盘管理-草稿箱
 BroseDaTa:'Property_BroseDaTa',//楼盘管理-浏览数据
 ZyCoupon:'Property_ZyCoupon',//楼盘管理-中原优惠券
 AgentProperty: 'Agent_Property', //代理人楼盘列表
 Agent: 'Property_Agent', // 楼盘管理-楼盘代理人
 Recommend: 'Property_Recommend',
 EditJournal: 'Property_Operation',
 JournalProperty:'Property_JournalProperty',
 Terms: 'Property_Terms', // 楼盘管理-放盘条款
 Messages: 'Property_Message', //楼盘管理-留言管理
 Charges: 'Property_Charges', //楼盘管理-收费标准
 Indent: 'Indent', //订单管理
 Order: 'Indent_IndentManage', //订单管理-订单管理
 Message: 'Message', //消息中心
 MessageManage: 'Message_Message', // 消息中心_消息中心,
 HelpCenter: 'HelpCenter', // 帮助中心-帮助中心
 HelpTerms: 'HelpCenter_Terms', // 帮助中心-放盘条款
 HelpCharges: 'HelpCenter_Terms_Charges', // 帮助中心-收费标准
 HelpCoinPayment: 'HelpCenter_PaymentMethod', // 帮助中心-付款方式
 HelpFeature: 'Help_Feature', // 帮助中心-功能介绍
 AddDepartment: 'addDepartment',
 StaffingCreate: 'StaffingCreate',
 StaffingEdit: 'StaffingEdit',
 StaffingTransfer: 'StaffingTransfer',
 BaseTemplate: 'BaseTemplate',
 Post: 'post',
 RecordOrganization: 'RecordOrganization',
 RecordPersonal: 'RecordPersonal',
 RecordDetail: 'RecordDetail',
 OrderPay: 'OrderPay',
 OrderDetail: 'OrderDetail',
 Login: 'Login',
 SelectRole: 'SelectRole',
 AddOrEditRole: 'AddOrEditRole',
 AppDownload: 'AppDownload', // app下载
 QRCodeDownload: 'QRCodeDownload' // 二维码下载
};

const routeIcons = {
 Home_HomePage: '#iconloupanguanli2', //首页-首页
 System_CompanyProfile: '#icongongsiziliao', //业务设置-公司资料
 System_Deal:'#iconshuju2',//业务设置-成交数据
 System_Branch: '#iconfenhangguanli1', //业务设置-分行管理
 System_Org: '#iconzuzhiguanli', //业务设置-组织管理
 System_Employee: '#iconyuangongguanli1', //业务设置-员工管理
 System_Operation: '#iconcaozuorizhi', //业务设置-操作日志
 Coin_CoinManage: '#iconjinbiguanli1', //金币管理-金币管理
 Coin_Record: '#iconjinbijilu', //金币管理-金币记录
 Coin_PaymentMethod: '#iconfukuanfangshi', //金币管理-付款方式
 Property_PropertyManage: '#iconloupanguanli2', //楼盘管理-楼盘管理
 Property_Agent: '#iconloupandailiren1', // 楼盘管理-楼盘代理人
 Property_Terms: '#iconfangpantiaokuan', // 楼盘管理-放盘条款
 Property_Message: '#iconliuyanguanli', //楼盘管理-留言管理
 Property_Charges: '#iconshoufeibiaozhun', //楼盘管理-收费标准
 Property_Recommend:'#icontuiqiancishujilu',//楼盘管理-置顶记录
 Property_Operation:'#iconxiugaigaiyao-copy',//楼盘管理-操作记录
 Indent_IndentManage: '#icondingdanguanli2', //订单管理-订单管理
 Message_Message: '#iconxiaoxi', //消息中心_消息中心
 HelpCenter_Terms: '#iconfangpantiaokuan', // 帮助中心-放款条款
 HelpCenter_Charges: '#iconshoufeibiaozhun', // 帮助中心-收费标准
 HelpCenter_PaymentMethod: '#iconfukuanfangshi', // 帮助中心-付款方式
 Help_Feature: '#icongongnengjieshao', // 帮助中心-功能介绍
 PersonalCenter: '#icongerenzhongxin'
};

export default {
 getCookie, //获取cookie

 setCookie, //写入cookie

 delCookie, //删除cookie

 getApi, //获取api配置

 getTicket, //获取访客gid

 getDictionary, //获取字典

 getAppConfig, //获取app版本号

 config, //通用配置

 getGid,

 checkLogin,

 imgResize,

 routeNameLists,

 routeIcons,

 obtainAndSetUserInfo,

 obtainAndSetRoutes,

 obtainAndSetPermissions,
 guide,
 userPageSize,
 getPageSize,
 getcompanyCategorys
};

//获取api配置
function getApi() {
 const baseUrl = config.baseUrl;
 return {
  LoginEmail: `${baseUrl}CompanyUser/LoginEmail`, //第三方登录
  SearchUserAgentPropertyByOrganization: `${baseUrl}Property/SearchUserAgentPropertyByOrganization`, //搜索房源列表
  AllowAddProperty: `${baseUrl}Department/AllowAddProperty`, //判断组织是否可以放盘
  UpdateDepartmentStatusByID: `${baseUrl}Department/UpdateDepartmentStatusByID`, // 停/启用组织
  UpdateDepartment: `${baseUrl}Department/UpdateDepartment`, // 编辑组织信息
  RemoveDepartment: `${baseUrl}Department/RemoveDepartment`, // 移除组织
  GetAllStoreByCompanyID: `${baseUrl}Store/GetAllStoreByCompanyID`, // 公司 下的分行
  AddDepartment: `${baseUrl}Department/AddDepartment`, // 增加组织
  SearchAllCompanyUserInfo: `${baseUrl}CompanyUser/SearchAllCompanyUserInfo`, // 当前组织下所有的员工搜索，包含子组织的
  RemoveProperty: `${baseUrl}Property/RemoveProperty`, //移除房源-未付款的
  PropertyColumnsSettingExt: `${baseUrl}Estate/PropertyColumnsSettingExt`, //修改用户楼盘管理自定义显示字段
  UpdatePropertyOwner: `${baseUrl}Property/UpdatePropertyOwner`, //修改房源归属人
  SearchUserCoinRecord: `${baseUrl}Department/SearchUserCoinRecord`, //查询当前人的金币记录
  SearchUserCoinByDepartmentIDRecord: `${baseUrl}Department/SearchUserCoinByDepartmentIDRecord`, //查询组织下员工金币记录
  SearchDepartmentCoinRecord: `${baseUrl}Department/SearchDepartmentCoinRecord`, //查找组织金币记录
  GetDepartmentById: `${baseUrl}Department/GetDepartmentById`, //查询角色
  SendCoin: `${baseUrl}Coin/SendCoin`, //分配屋币 回收屋币
  BathSendCoin: `${baseUrl}Coin/BathSendCoin`, //分配全部屋币 回收全部屋币
  SearchMarketParticipantsUser: `${baseUrl}CompanyUser/SearchMarketParticipantsUser`, //查询组织放盘人
  GetCompanyUserInfo: `${baseUrl}CompanyUser/GetUserInfo`, //获取当前登录用户的信息
  GetMenuPerByRoleID: `${baseUrl}Permission/GetMenuPerByRoleID`, //根据角色ID获取菜单集合（包含顶导和左导）
  GetPermissionByRoleId: `${baseUrl}Permission/GetPermissionByRoleId`, //根据角色ID获取权限code集合
  PropertyColumnsSetting: `${baseUrl}Estate/PropertyColumnsSetting`, //楼盘管理自定义显示字段
  GetDepartmentsTreeByParentID: `${baseUrl}Department/GetDepartmentsTreeByParentID`, //组织树结构
  SearchAllDepartmentsByParentID : `${baseUrl}Department/SearchAllDepartmentsByParentID`, //组织扁平结构
  GetUserCoinDetail: `${baseUrl}CompanyUser/GetUserCoinDetail`, // 首页个人金币详情
  GetCurrentUserPropertyDetail: `${baseUrl}CompanyUser/GetCurrentUesrPropertyDetail`, //个人首页楼盘详情
  GetOrganizationCoinDetail: `${baseUrl}Department/GetOrganizationCoinDetail`, //首页组织的详情
  GetOrganizationDetailByMonth:`${baseUrl}Department/GetOrganizationDetailByMonth`,//首页按月获取详情
  GetDepartments: `${baseUrl}Department/GetDepartments`, //查找组织
  GetPropertyCapabilities: `${baseUrl}Property/GetPropertyCapabilities`, //楼盘升级时查找楼盘相关订单数据
  BuyPropertyUpgradeType: `${baseUrl}Property/BuyPropertyUpgradeType`, //楼盘直接升级
  CloseOrderAsync: `${baseUrl}Order/CloseOrderAsync`, //关闭订单
  SearchPropertyList: `${baseUrl}Property/SearchUserPublishPropertyByOrganization`, //搜索房源列表
  TelephoneUnbinding: `${baseUrl}CompanyUser/TelephoneUnBinding`, //解绑手机
  TelephoneBindToken: `${baseUrl}CompanyUser/TelephoneBindToken`, //手机绑定
  UpdateSelf: `${baseUrl}CompanyUser/UpdateSelf`, //修改经纪人信息
  RetrieveTelephone: `${baseUrl}CompanyUser/RetrieveTelephone`,
  GetPropertyCount: `${baseUrl}Property/GetPropertyCount`, //房源数量
  GetPropertyUsersequence: `${baseUrl}Property/GetPropertyUsersequence`,//获取列表排序
  UpdateCompanyDetail: `${baseUrl}Company/UpdateCompanyDetail`, //更新公司的信息
  SearchOperationLog: `${baseUrl}Department/SearchOperationLog`, //查询操作日志
  GetRecaptcha: `${baseUrl}Common/GetRecaptcha`, //获取验证码
  PreLogin: `${baseUrl}CompanyUser/PreLogin`, //預登录
  Login: `${baseUrl}CompanyUser/Login`, //登录
  SwithLogin: `${baseUrl}CompanyUser/SwithLogin`, //切换登录
  RefeshToken: `${baseUrl}CompanyUser/RefeshToken`, //刷新token
  SetDefaultDepartment: `${baseUrl}CompanyUser/SetDefaultDepartment`, //设置登录的默认部门
  RetrievePassword: `${baseUrl}CompanyUser/RetrievePassword`, //獲取驗證碼
  VerifyCodeToken: `${baseUrl}CompanyUser/VerifyCodeToken`, //獲取token
  UseTokenRetrievePassword: `${baseUrl}CompanyUser/UseTokenRetrievePassword`, //重置密碼
  SearchStore: `${baseUrl}Store/SearchStore`, //獲取分行列表
  GetFullAgentCompany: `${baseUrl}Company/GetFullAgentCompany`, //获取本公司资料
  RemoveStore: `${baseUrl}Store/RemoveStore`, //刪除分行
  SingleStoreByStoreID: `${baseUrl}Store/SingleStoreByStoreID`, //获取单个分行详情
  AddStore: `${baseUrl}Store/AddStore`, //增加分行
  UpdateStore: `${baseUrl}Store/UpdateStore`, //更新分行
  GetAccountGuide: `${baseUrl}CompanyUser/GetAccountGuide`, //获取引导页
  SearchDistinctOrganizationUserInfo: `${baseUrl}CompanyUser/SearchDistinctOrganizationUserInfo`, // 查询用户--进行聚合
  SearchUserAllResource:`${baseUrl}CompanyUser/SearchUserAllResource`,
  SearchCompanyUserInfo: `${baseUrl}CompanyUser/SearchCompanyUserInfo`, // 查詢員工
  AddUserInfo: `${baseUrl}CompanyUser/AddUserInfo`, // 新增員工
  UpdateUserInfo: `${baseUrl}CompanyUser/UpdateUserInfo`, // 更新員工信息
  DeleteUserInfo: `${baseUrl}CompanyUser/DeleteUserInfo`, // 刪除員工
  UpdateUserStatuss: `${baseUrl}CompanyUser/UpdateUserStatuss`, // 啟停用員工
  SearchUserProperty: `${baseUrl}CompanyUser/SearchUserProperty`, // 获取指定员工其组织及组织下的楼盘列表
  SerachRoleInfo: `${baseUrl}Role/SerachRoleInfo`, // 查詢角色
  GetRoleInfoTreeByParentID: `${baseUrl}Role/GetRoleInfoTreeByParentID`, //查詢角色樹
  HeadImagePath: `${baseUrl}CompanyUser/HeadImagePath`, // 更新员工头像
  UserpropertyMobility: `${baseUrl}CompanyUser/UserpropertyMobility`, // 樓盤轉移
  CrossDepartmentTrans: `${baseUrl}Property/CrossDepartmentTransferProperty`, // 樓盤跨组轉移
  UserOrganizationalMobility: `${baseUrl}CompanyUser/UserOrganizationalMobility`, // 人員調動
  SerachChildRoleInfoByParentRoleID: `${baseUrl}Role/SerachChildRoleInfoByParentRoleID`, // 員工角色的子角色信息
  GetUserInfoByAccountID: `${baseUrl}CompanyUser/GetUserInfoByAccountID`, // 获取用户的信息
  UserDepartmentCionPropertyCount: `${baseUrl}CompanyUser/UserDepartmentCionPropertyCount`, // 獲取員工在某組別下的金幣數&&樓盤數
  SearchAgentUser: `${baseUrl}CompanyUser/SearchAgentUser`, // 查询组织代理人
  UpdatePropertyAgent: `${baseUrl}Property/UpdatePropertyAgent`, // 替换房源的某一个代理人
  UpdateUser: `${baseUrl}User/UpdateUser`, //修改用户信息
  RegisterUser: `${baseUrl}User/RegisterUser`, //用户注册
  SearchDictionaryInfo: `${baseUrl}DictionaryInfo/SearchDictionaryInfo`, //数据字典
  GetPhasesAndBuildingForPublish:`${baseUrl}Estate/GetPhasesAndBuildingForPublish`,//获取刊登所需期数,栋座
  GetBuildingFloorPublish:`${baseUrl}Estate/GetBuildingFloorPublish`,//获取楼层,单元信息
  SearchPropertyPlanImage:`${baseUrl}Property/SearchPropertyPlanImage`,//获取平面图
  GetPropertyPlanSearchParameter:`${baseUrl}Property/GetPropertyPlanSearchParameter`,//获取平面图筛选项
  GetPropertySubCategoryNotAllow:`${baseUrl}Property/GetPropertySubCategoryNotAllow`,//获取楼盘类型 禁止选择
  GetGscope: `${baseUrl}DictionaryInfo/GetGscope`,
  UpdateLeaveMessage: `${baseUrl}User/UpdateLeaveMessage`, //更改留言
  ReplyLeaveMessage: `${baseUrl}User/ReplyLeaveMessage`, //回復留言
  DeleteLeaveMessage: `${baseUrl}User/DeleteLeaveMessage`, //刪除留言
  AddLeaveMessage: `${baseUrl}User/AddLeaveMessage`, //添加留言
  SearchLeaveMessage: `${baseUrl}User/SearchLeaveMessage`, //搜索留言(带房源信息)
  SearchCollection: `${baseUrl}User/SearchCollection`, //搜索收藏
  DeleteCollection: `${baseUrl}User/DeleteCollection`, //删除收藏
  SearchGscope: `${baseUrl}DictionaryInfo/SearchGscope`, //搜索板块信息
  SetAccountResources: `${baseUrl}CompanyUser/SetAccountResources`, //设置用户的资源值
  GetAccountResource: `${baseUrl}CompanyUser/GetAccountResource`, //获取用户的资源值
  SearchEstate: `${baseUrl}Estate/SearchEstate`, //搜索楼盘
  AddProperty: `${baseUrl}Property/AddProperty`, // 新增房源
  UpdateProperty: `${baseUrl}Property/UpdateProperty`, // 修改房源
  PropertyScore: `${baseUrl}Property/PropertyScore`, //房源分数
  PropertyVerify: `${baseUrl}Property/PropertyVerify`, //使用需要重新房源验证文件
  GetCompanyPropertyPriceSet: `${baseUrl}Property/GetCompanyPropertyPriceSet`, //获取不同类型楼盘金币钻石使用数量及限制

  SearchUserPublishProperty: `${baseUrl}Property/SearchUserPublishProperty`, //  搜索房源(带排名,用户中心用)
  GetProperty: `${baseUrl}Property/GetProperty`, // 获取单个房源信息
  GetPropertyPriceStat: `${baseUrl}Property/GetPropertyPriceStat`,
  GetPropertyUserInfoFullById: `${baseUrl}Property/GetPropertyUserInfoFullById`, //根据房源id获取放盘人信息(全量字段)
  UpdatePropertyStatus: `${baseUrl}Property/UpdatePropertyStatus`, // 修改房源状态
  UpdatePropertyShowStatus: `${baseUrl}Property/UpdatePropertyShowStatus`, // 修改房源状态
  RefreshPropertyAndRecommendById: `${baseUrl}Property/RefreshPropertyAndRecommendById`, //刷新房源
  UpdatePropertySource: `${baseUrl}Property/UpdatePropertySource`, //更新房源为业主盘
  IsExistPropertyNo: `${baseUrl}Property/IsExistPropertyNo`, //判断物业编号是否重复
  Upload: `${baseUrl}upload`, // 上传文件
  uploadCompanyLogo: `${baseUrl}uploadCompanyLogo`, // 上传文件
  RotateImage: `${baseUrl}Common/RotateImage`, // 上传文件旋转
  VerifyRetrievePasswordKey: `${baseUrl}User/VerifyRetrievePasswordKey`, // 验证找回密码key
  resetPassword: `${baseUrl}User/resetPassword`, // 密码找回-设置密码
  ChangePassword: `${baseUrl}CompanyUser/ChangePassword`, //修改密码
  GetRegisterVerifySms: `${baseUrl}User/GetRegisterVerifySms`, // 发送短信验证码
  GetPropertyFullById: `${baseUrl}Property/GetPropertyFullById`, // 获取单个房源信息全量，
  SearchOrderRecord: `${baseUrl}User/SearchOrderRecord`, //搜索订购记录
  RequiredProperty:`${baseUrl}Property/RequiredProperty`, //付款楼盘是否缺少必填项
  PropertyCoinPaymentOrder: `${baseUrl}Order/PropertyCoinPaymentOrder`, //屋币支付.
  PaymentOrder: `${baseUrl}Order/PaymentOrder`, 
  CreatePropertyOrder: `${baseUrl}Property/CreatePropertyOrder`, //创建支付订单
  SearchEstateSuggester: `${baseUrl}Estate/SearchEstateSuggester`, // 搜索楼盘联想
  GetEstate: `${baseUrl}Estate/GetEstate`, //根据楼盘id查楼盘信息
  GetStationDuration:`${baseUrl}Property/GetStationDuration`,//根据楼盘id获取港铁时间
  SendUserVerifyInfo: `${baseUrl}User/SendUserVerifyInfo`, //发送验证邮件
  VerifyRegisterKey: `${baseUrl}User/VerifyRegisterKey`, // 验证注册的key
  SearchPropertyPriceSet: `${baseUrl}DictionaryInfo/SearchPropertyPriceSet`, // 搜索房源服务价格
  GetCompanyPropertyRecommendPriceSet: `${baseUrl}Property/GetCompanyPropertyRecommendPriceSet`, // 获取购买指定需要的配置
  BuyRecommendCount: `${baseUrl}Property/BuyRecommendCount`, // 购买置顶
  SearchRecommendLogs: `${baseUrl}Property/SearchRecommendLogs`, // 置顶列表
  SearchAllRecommendLogs: `${baseUrl}Property/SearchAllRecommendLogs`, // 置顶页导出
  SearchPropertyOperationLog:`${baseUrl}Property/SearchPropertyOperationLog`, // 操作楼盘log
  GetOperationUpdatePropertyInfo:`${baseUrl}Property/GetPropertyOperationUpdatePropertyInfo`, // 楼盘修改表单
  CreatePaypalOrder: `${baseUrl}Order/CreatePaypalOrder`, //创建paypal订单，并返回订单id
  CapturePaypalOrder: `${baseUrl}Order/CapturePaypalOrder`, //用户批准付款后回调
  CreatePayDollarOrder:`${baseUrl}Order/CreatePayDollarOrder`,//创建paydollar订单，并返回订单id
  CapturePayDollarOrder: `${baseUrl}Order/CapturePayDollarOrder`, //用户批准付款后回调
  SearchPropertyCoinSet: `${baseUrl}DictionaryInfo/SearchPropertyCoinSet`, //搜索屋币信息
  GetCompanyPropertyAutoRecommendPriceSets: `${baseUrl}Property/GetCompanyPropertyAutoRecommendPriceSets`, //自动置顶配置
  BuyAutoRecommendDays: `${baseUrl}Property/BuyAutoRecommendDays`, // 购买自动置顶
  GetPropertyAutoRecommendLog: `${baseUrl}Property/GetPropertyAutoRecommendLog`, // 房源是否购买了自动置顶
  SearchCouponBatchEstate:`${baseUrl}Property/SearchCouponBatchEstate`,//中原优惠券查询

  AddPropertyCoinOrder: `${baseUrl}User/AddPropertyCoinOrder`, //添加屋币订单
  GetOrderRecord: `${baseUrl}User/GetOrderRecord`, //根据id获取订单信息
  RegisterVerifySms: `${baseUrl}User/RegisterVerifySms`, // 发送短信验证码
  GetBankTransferPaymentOrderHelp: `${baseUrl}Order/GetBankTransferPaymentOrderHelp`, //获取银行转账支付指南邮件
  GetAppConfig: `${baseUrl}AppConfig/GetAppConfig`, //获取app配置

  GetUserInfo: `${baseUrl}CompanyUser/GetUserInfo`, //获取当前登录用户的信息
  SearchStaffUser: `${baseUrl}CompanyUser/SearchStaffUser`, // 查询组织代理人
  SearchMessageCenter: `${baseUrl}Message/SearchMessageCenter`, //查询消息
  GetUserMessage: `${baseUrl}Message/GetUserMessage`, //消息概覽
  GetAllMessage:`${baseUrl}Message/GetAllNoReadMessageCenter`,//实时获取未读信息
  UpdateMessageStatus: `${baseUrl}Message/UpdateMessageStatus`,
  GetCompanyCofig: `${baseUrl}Property/GetCompanyCofig`,
  GetCommonWord: `${baseUrl}Property/GetCommonWord`, //刊登楼盘获取常用词
  GetBusinessCommonWord: `${baseUrl}Property/GetBusinessCommonWord`, //工商专用常用词
  SerachRoleInfoByCompany: `${baseUrl}Role/SerachRoleInfoByCompany`, //查询公司角色
  // 利嘉阁需求
  IsExistCategoryNo: `${baseUrl}Property/IsExistCategoryNo`,
  PropertyInfoExterna: `${baseUrl}Property/PropertyInfoExterna`,
  GetCustomPropertyCoinCountPriceOrder: `${baseUrl}User/GetCustomPropertyCoinCountPriceOrder`, //查询金额
  AddCustomPropertyCoinOrder: `${baseUrl}User/AddCustomPropertyCoinOrder`, //添加自定义金币订单
  GetKeyword: `${baseUrl}Common/GetKeyword`, //获取
  RotateImages: `${baseUrl}Common/RotateImages`, //批量旋转图片
  GetPopupMessage: `${baseUrl}CompanyUser/GetPopupMessage`, //获取最新消息提示

  /* 砖石需求 */
  DiamondPaymentOrder: `${baseUrl}Order/DiamondPaymentOrder`,
  AllUserCoinDiamond: `${baseUrl}Department/SearchDepartmentAllUserCoinRecord`,//导出全部员工excel
  AllDepCoinDiamond: `${baseUrl}Department/SearchDepartmentAllCoinRecord`,//导出全部组别excel
  // DepAllCoinDiamond: `${baseUrl}Department/SearchDepartmentUserInfoCoinDiamond`,
  SearchAllOrderRecord:`${baseUrl}User/SearchAllOrderRecord`,//导出全部订单excel
  SearchDepartmentDiamondRecord: `${baseUrl}Department/SearchDepartmentDiamondRecord`, //查找组织砖石记录
  SearchUserDiamondRecord: `${baseUrl}Department/SearchUserDiamondRecord`, //查询当前人的砖石记录
  SendDiamond: `${baseUrl}Coin/SendDiamond`, //分配钻全部石 回收全部钻石
  BathSendDiamond: `${baseUrl}Coin/BathSendDiamond`, //分配钻石 回收钻石
  SearchDiamondSet: `${baseUrl}DictionaryInfo/SearchDiamondSet`, //搜索钻石信息
  AddDiamondOrder: `${baseUrl}User/AddDiamondOrder`, //添加钻石订单
  GetCustomDiamondCountPriceOrder: `${baseUrl}User/GetCustomDiamondCountPriceOrder`, //查询金额
  AddCustomDiamondOrder: `${baseUrl}User/AddCustomDiamondOrder`, //添加自定义钻石订单
  RenewProperty: `${baseUrl}Property/RenewProperty`,//  批量续期房源
  GetPhoneCodeInfo:`${baseUrl}DictionaryInfo/GetInternationalDialingCodeInfo`,//获取电话号前缀
  // 草稿箱
  AddPropertyDraft: `${baseUrl}Property/AddPropertyDraft`, //添加和修改房源草稿箱
  SearchPropertyDraft: `${baseUrl}Property/SearchPropertyDraft`, //查询房源草稿
  RemovePropertyDraft: `${baseUrl}Property/RemovePropertyDraft`, //删除房源草稿
  GetDefaultUserContactImage: `${baseUrl}CompanyUser/GetDefaultUserContactImage`, //  获取默认头像
  UpdatePropertyAllOwner: `${baseUrl}Property/UpdatePropertyAllOwner`, //修改房源归属人
  // 删除员工
  PreRemoveUserAllResource:`${baseUrl}Property/PreRemoveUserAllResource`,//请求删除人相关数据
  RemoveUserAllResource:`${baseUrl}Property/RemoveUserAllResource`,//选中后彻底删除
  //多盘置顶
  BathRefreshProperty:`${baseUrl}Property/BathRefreshProperty`,

  GetEvaluationApi:`${baseUrl}Property/GetEvaluationApi`,//估价
  // 帮助中心
  GetCategorys:`${baseUrl}HelpCenter/GetCategorys`,//获取分类
  GetHotQuestions:`${baseUrl}HelpCenter/GetHotQuestions`,//获取热门问题
  GetCommonQuestions:`${baseUrl}HelpCenter/GetCommonQuestions`,//获取常见问题
  GetTopQuestions:`${baseUrl}HelpCenter/GetTopQuestions`,//获取置顶问题
  GetListByCategoryId:`${baseUrl}HelpCenter/GetListByCategoryId`,//获取问题列表，根据分类（前端无需判断二级分类） 无分页
  SearchQuestions:`${baseUrl}HelpCenter/SearchQuestions`,//帮助中心搜索
  GetQuestionById:`${baseUrl}HelpCenter/GetQuestionById`,//获取问题详情
  GetRecommendById:`${baseUrl}HelpCenter/GetRecommendById`,//获取推荐文章
  GetQuestionByIds:`${baseUrl}HelpCenter/GetQuestionByIds`,//获取最近浏览的数据（浏览信息存本地，根据ID获取）
  PushException:`${baseUrl}CompanyUser/PushException`,//错误log

  GetPropertyBrowse:`${baseUrl}Property/GetPropertyBrowse`,//获取楼盘联络数据
  SearchPropertyDeal:`${baseUrl}Property/SearchPropertyDeal`,//搜索成交数据
  AddPropertyDeal:`${baseUrl}Property/AddPropertyDeal`,//新增房源成交
  UpdatePropertyDeal:`${baseUrl}Property/UpdatePropertyDeal`,//修改房源成交
  DeletePropertyDeal:`${baseUrl}Property/DeletePropertyDeal`,//删除房源成交
  GetPropertyUpdateGroupLogs:`${baseUrl}Property/GetPropertyUpdateGroupLogs`,//获取房源多屋苑的楼盘历史数据
 
  UseCoupon:`${baseUrl}Coin/UseCoupon`,//使用兌換券
  SearchCoupon:`${baseUrl}Coin/SearchCoupon`,//查詢兌換券列表
  SetAccountSwitch:`${baseUrl}CompanyUser/SetAccountSwitch`,
  VerifyCouponKeyword:`${baseUrl}Property/VerifyPropertyCouponKeyword`,//优惠券是否能使用
  VerifyCouponEligibility:`${baseUrl}Property/VerifyPropertyCouponEligibility`,//是否展示优惠券
  SearchCouponEstate:`${baseUrl}Estate/SearchCouponEstate`,//优惠券页面屋苑搜索
  }
}

//获取cookie
function getCookie(name) {
 let arr,
  reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)');
 if ((arr = document.cookie.match(reg))) {return unescape(arr[2]);}
 return null;
}

//写入cookie 不提供失效时间时，cookie默认有效期为2个月
function setCookie(key, value, expires) {
 const date = expires ? new Date(expires * 1000) : new Date();
 date.setTime(date.getTime() + 60 * 60 * 1000 * 24 * 60);
 /* document.cookie = `${key}=${value};expires=${date.toGMTString()};path=/;${
 env_type == 3 ? 'secure=true' : ''
 }`; */
 document.cookie = `${key}=${value};expires=${date.toGMTString()};path=/`;
}

//删除cookie
function delCookie(key) {
 var date = new Date();
 date.setTime(date.getTime() - 1);
 var delValue = getCookie(key);
 if (Boolean(delValue)) {
  /* document.cookie = `${key}=${delValue};expires=${date.toGMTString()};path=/;domain=house730.com;${
  env_type == 3 ? 'secure=true' : ''
  }`; */
  document.cookie = `${key}=${delValue};expires=${date.toGMTString()};path=/`;
  document.cookie = `${key}=${delValue};expires=${date.toGMTString()};domain=.pms.house730.com;path=/`;
  document.cookie = `${key}=${delValue};expires=${date.toGMTString()};domain=.simpms.house730.com;path=/`;
  document.cookie = `${key}=${delValue};expires=${date.toGMTString()};domain=.uatpms.house730.com.cn;path=/`;
  document.cookie = `${key}=${delValue};expires=${date.toGMTString()};domain=.house730.com.cn;path=/`;
  document.cookie = `${key}=${delValue};expires=${date.toGMTString()};domain=.house730.com;path=/`;
 }
}
//访客token生成
function getTicket() {
 let gid = GetCookie('Y190cmFja2lk');
 if (gid) {return gid;}
 
  gid = getGid().replace(/-/g, '');
  setCookie('Y190cmFja2lk', gid);
  return gid;
 
}

//生成GUID
function getGid() {
 return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
  let r = (Math.random() * 16) | 0,
   v = c == 'x' ? r : (r & 0x3) | 0x8;
  return v.toString(16);
 });
}

//获取字典参数
function getDictionary() {
  const CACHE_PREFIX = 'RGljdGlvbmFyeQ'; // 缓存前缀
  const CURRENT_VERSION = '20251117'; // 当前版本
  
  return new Promise((resolve, reject) => {
    const cacheKey = `${CACHE_PREFIX}${CURRENT_VERSION}`;
    const cached = sessionStorage.getItem(cacheKey);
    
    if (cached) {
      resolve(JSON.parse(cached));
      return;
    }
    
    // 清理旧版本缓存
    cleanupOldVersions(CACHE_PREFIX, CURRENT_VERSION);
    
    axios.get(getApi().SearchDictionaryInfo).then(res => {
      if (res.data.code === 0 && res.data.result) {
        const dicData = {};
        res.data.result.forEach(r => (dicData[r.itemName] = r));
        sessionStorage.setItem(cacheKey, JSON.stringify(dicData));
        resolve(dicData);
      } else {
        reject(new Error('API返回数据格式错误'));
      }
    }).catch(reject);
  });
}

// 自动清理旧版本
function cleanupOldVersions(prefix, currentVersion) {
  const keysToRemove = [];
  
  for (let i = 0; i < sessionStorage.length; i++) {
    const key = sessionStorage.key(i);
    if (key && key.startsWith(prefix) && key !== `${prefix}${currentVersion}`) {
      keysToRemove.push(key);
    }
  }
  
  keysToRemove.forEach(key => sessionStorage.removeItem(key));
}

// function getDictionary() {
//   // 接口新增时候，需手动处理版本更新
//   const pmsver = "20251117"; // 与axios拦截器中的版本保持一致
//   const oldver = ''
//   const cacheKey = `RGljdGlvbmFyeQ${pmsver}`;
//   const cacheOldKey = `RGljdGlvbmFyeQ${oldver}`;
//   const dic = sessionStorage.getItem(cacheKey);

// //  const dic = sessionStorage.getItem('RGljdGlvbmFyeQ');
//  return new Promise((resolve, reject) => {
//   dic
//    ?
//    resolve(JSON.parse(dic)) :
//    axios.get(getApi().SearchDictionaryInfo).then(res => {
//     let dicData = {};
//     if (res.data.code === 0 && res.data.result) {
//      res.data.result.forEach(r => (dicData[r.itemName] = r));
//      sessionStorage.setItem(cacheKey, JSON.stringify(dicData));
//      sessionStorage.removeItem(cacheOldKey);

//     //  sessionStorage.setItem('RGljdGlvbmFyeQ', JSON.stringify(dicData));
//      resolve(dicData);
//     } else reject();
//    }, reject);
//  });
// }

// 获取版本号
function getAppConfig(version) {
 const lang = getLang();
 const appConfig = 'config';
 return new Promise((resolve, reject) => {
  axios.get(getApi().GetAppConfig + `?version=${appConfig}`).then(res => {
   if (res.data.code === 0 && res.data.result) {
    version == res.data.result.version ? resolve(true) : resolve(false);
   } else {reject();}
  }, reject);
 });
}

//檢測登錄
function checkLogin() {}

// 图片懒加载
function imgResize(value, type) {
 if (!value && type === 'user') {return '/house-bg.png';}
 if (!value) {return '/house-bg.png';}
 const webp = typeof window == 'object' ? checkWebp() : '';
 if (type === 'full') {value = value + '?x-oss-process=style/' + '1080xauto_f' + webp;}
 else if (type === 'company') {value = value + '?x-oss-process=style/' + '360x270_c' + webp;}
 else if (type === 'user') {value = value + '?x-oss-process=style/' + '150xauto_f' + webp;}
 else {value = value + '?x-oss-process=style/' + '640x480_c' + webp;}
 return value;
}

// 檢測是否支持webp
function checkWebp() {
 if (window._webp != undefined) {return window._webp;}
 try {
  if (
   document
   .createElement('canvas')
   .toDataURL('image/webp')
   .indexOf('data:image/webp') == 0
  )
   {window._webp = '.webp';}
  else {window._webp = '';}
 } catch (err) {
  window._webp = '';
 }
 return window._webp || '';
}

//获取用户信息
function obtainAndSetUserInfo() {
 return new Promise((resolve, reject) => {
  axios.get(getApi().GetUserInfo).then(res => {
   if (res.data.code === 0 && res.data.result) {
    res.data.result.roleList.forEach(item => {
     if (item.roleID === res.data.result.roleID) {
      res.data.result.roleName = item.roleName;
     }
    });
    store.commit('setUserInfo', res.data.result);
    resolve();
   } else {
    reject();
   }
  });
 });
}
function filterRoutes(conditions,arraylist){
  let routearray = []
  routearray = arraylist.filter(item => !conditions.includes(item.functionCategoryCode));
  store.commit('setRoutes', routearray);
}
//获取路由信息
function obtainAndSetRoutes(roleID) {
 return new Promise((resolve, reject) => {
  axios
   .get(getApi().GetMenuPerByRoleID, {
    params: {
     roleID: roleID
    }
   })
   .then(res => {
    if (res.data.code === 0 && res.data.result) {
      // 中原工商住宅 需隐藏某些路由模块 
      getcompanyCategorys().then((suc)=>{
        // if(suc == 2){
        //   let filterCondition= ['System']
        //   filterRoutes(filterCondition,res.data.result)
        // }else 
        if(suc){
          let filterCondition= ['Coin','Indent','System']
          let targetArray = []
          // 隐藏楼盘管理 -->代理人概要
          targetArray = res.data.result
          targetArray = targetArray.map(item => {
            if (item.functionModules && item.functionCategoryCode == 'Property') {
              item.functionModules= item.functionModules.filter(subItem => subItem.functionModuleCode !== 'Property_Agent');
            }
            return item;
          });
          filterRoutes(filterCondition,targetArray)
        }else{
          store.commit('setRoutes', res.data.result);
        }
      })
    //  store.commit('setRoutes', res.data.result);
     resolve();
    } else {
     reject();
    }
   });
 });
}

//获取某角色的权限code表
function obtainAndSetPermissions(roleID) {
 return new Promise((resolve, reject) => {
  axios
   .post(getApi().GetPermissionByRoleId, {
    roleID: roleID
   })
   .then(res => {
    if (res.data.code === 0 && res.data.result) {
      // console.log("res.data.result",res.data.result)
     store.commit('setPermissions', res.data.result);
     resolve();
    } else {
     reject();
    }
   });
 });
}
// 新手引导页面
function guide(Driver, steps) {
 const driver = new Driver({
  offset: 7,
  nextBtnText: '下一步', // Next
  doneBtnText: '完成',
  allowClose: false,
 });
 driver.defineSteps(steps);
 driver.start();
}
function getcompanyCategorys(){
  return new Promise((resolve, reject) => {
    axios
     .get(getApi().GetCompanyCofig)
     .then(res => {
      if (res.data.code === 0 && res.data.result) {
       resolve(res.data.result.isDisabledPublish);
      } else {
       reject();
      }
     });
   });
}
// 获取用户分页数据
function getPageSize(accountID,xcount){
  let broData = JSON.parse(localStorage.getItem("userPageCount"))
  if(broData){
    for(let i =0;i<broData.length;i++){
       if(broData[i].accountID == accountID && broData[i][xcount]){
        return broData[i][xcount]
       }
    }
  }
}
// 保存不同账户不同页面选中的项数
function userPageSize(accountID,xcount,val){
  // 如果是空的 新建数组
  let userPage = {
    accountID:accountID,
    proPageCount:'',
    pcoinInPageCount:'',
    mcoinInPageCount:'',
    pcoinRePageCount:'',
    mcoinRePageCount:'',
    percoinRePageCount:'',
    perdiaRePageCount:'',
    orderPageCount:'',
    staffPageCount:'',
    statraPageCount:'',
    orgmanPageCount:'',
    departPageCount:'',
    journalPageCount:'',
    noticePageCount:'',
    messagePageCount:'',
    agentPageCount:'',
    dealPageCount:'',
    couponPageCount:'',
  }
  // let broData = JSON.parse(localStorage.getItem("userPageCount"))
  let strangeAccount = false
  new Promise((suc,err)=>{
    let broData = JSON.parse(localStorage.getItem("userPageCount"))
    suc(broData)
  }).then((broData)=>{
    if(accountID){
      if(broData){
        for(let i =0;i<broData.length;i++){
           if(broData[i].accountID == accountID){
            // 当为相同pagecount无须修改
            strangeAccount = false
            if(broData[i][xcount] == val) {break;}
            // 修改某一项某一个的count
            broData[i][xcount] = val
            localStorage.setItem('userPageCount',JSON.stringify(broData))
            break;
           }else{
            strangeAccount = true
           }
        }
        if(strangeAccount){
          // 压入一个新用户的count
            userPage[xcount] = val
            broData.push(userPage)
            localStorage.setItem('userPageCount',JSON.stringify(broData))
        }
      }else{
        let datas = []
        datas.push(userPage)
        userPage[xcount] = val
        localStorage.setItem('userPageCount',JSON.stringify(datas))
      }
    }else{
      console.log("无accountid")
    }
  })
}
